export default {
  arrayInputs: {
    background: 'lightgoldenrodyellow',
    border: 'solid 2px #020202',
    margin: '3%',
    display: 'flex',
    padding: '2%'
  },
  addButton: { margin: '3%' },
  addRemoveButton: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      paddingLeft: '4%'
    },
    removeButton: {
      margin: '10%',
      padding: "0 6px"
    },
    addBtn: { margin: '10%' },
    addIcon: {
      display: 'flex',
      justifyContent: 'center'
      }
  }
}
